import { render } from "./login.vue?vue&type=template&id=570dcbdf"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=570dcbdf&scope=true&lang=less"

import exportComponent from "G:\\workBench\\my_server_project\\eventvue\\myEvents\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__